import qs from "qs"
import axios, { AxiosResponse } from "axios"
import axiosInstance from "@/api/axios"
import { ZodError } from "zod"
import router from "@/router/index"
import errorTypeConst from "@common_lib/base/constants/errorTypeConst"
import extractLastSegment from "@/utils/extractLastSegment"

export const fetchAPI = async ({
  data,
  method,
  url,
  qsOptions,
  withCredentials,
  pageName,
  hasStatus,
  ...rest
}: {
  data?: object
  method?: "post" | "get"
  url: string
  qsOptions?: object
  withCredentials?: boolean
  pageName?: string
  hasStatus?: boolean
  [key: string]: unknown
}) => {
  const queryPass = axiosInstance.defaults.headers.common.Authorization
  const formData = qs.stringify({ ...data }, qsOptions)

  try {
    const res = await axiosInstance({
      ...rest,
      withCredentials: withCredentials !== false,
      method: method ?? "post",
      data: formData,
      url: queryPass ? `${url};jsessionid=${queryPass}` : url
    })

    const { status } = res.data

    if (status === errorTypeConst.DISABLED_FRONTEND_BACKEDN_SEPARATION.status) {
      const newUrl = import.meta.env.VITE_BASE_API_URL
        ? `${import.meta.env.VITE_BASE_API_URL}`
        : `${window.location.protocol}//${window.location.host.replace(
            /^[^.]*/,
            import.meta.env.VITE_BASE_API_SUBDOMAIN
          )}`

      window.location.href = newUrl
    }

    // 9w IP block是1002
    if (status === "1002") {
      if (errorTypeConst.IP_BLOCK.pageName !== pageName) {
        router.isReady().then(() => {
          router.push({ name: "IPBlock" })
        })
        return Promise.reject(res)
      }
    }

    if (status === errorTypeConst.SYSTEM_MAINTENANCE.status) {
      if (errorTypeConst.SYSTEM_MAINTENANCE.pageName !== pageName) {
        router.isReady().then(() => {
          router.push({ name: "SystemMaintenance" })
        })
        return Promise.reject(res)
      }
    }

    if (status === "1007") {
      if (errorTypeConst.IP_BLOCK.pageName !== pageName) {
        // TODO 要把下面註解拿掉
        // window.close()
        // window.location.href = "about:blank"
        return Promise.reject(res)
      }
    }

    if (
      status === errorTypeConst.NOT_AUTHORIZED.status ||
      status === errorTypeConst.USER_IS_NULL.status ||
      status === errorTypeConst.SESSION_TIMEOUT.status ||
      (url === "/member/playerService/queryPlayerInfo" &&
        status === errorTypeConst.FAIL.status)
    ) {
      return Promise.reject(errorTypeConst.NOT_AUTHORIZED.status)
    }
    if (status === errorTypeConst.INSUFFICIENT_PARAMETER.status) {
      return Promise.reject(errorTypeConst.INSUFFICIENT_PARAMETER.status)
    }
    if (status === errorTypeConst.CASINO_MAINTENANCE.status) {
      return Promise.reject(errorTypeConst.CASINO_MAINTENANCE.message)
    }
    if (res.data.error) {
      return Promise.reject(res.data)
    }
    if (hasStatus && res.data.status !== "0000") {
      return Promise.reject(res.data)
    }

    return Promise.resolve(res.data)
  } catch (error) {
    if (error instanceof ZodError) {
      throw new Error(`${error}, zod validate not pass`)
    }

    if (axios.isCancel(error)) {
      console.warn(`request canceled for ${extractLastSegment(url)}`)
      throw new Error(`request canceled for ${extractLastSegment(url)}`)
    }

    const err = error as { response: AxiosResponse }

    if (
      err.response &&
      url === "/member/playerService/queryPlayerInfo" &&
      err.response.status === 410 &&
      err.response?.data?.status === errorTypeConst.FAIL.status
    ) {
      console.warn(err.response.data.status_msg)
      return Promise.reject(errorTypeConst.NOT_AUTHORIZED.status)
    }

    throw new Error(`${error}`)
  }
}

export default fetchAPI
